import {findThirdPartyWeeklyBillingDetails} from "../Util/queries";
import {constructThirdPartyBillingDetails} from "../Factory/factory";
import {THIRD_PARTY_BILLING_DETAILS} from "../Reducers/thirdPartyBillingReducer";

const getPartnerThirdPartyBillingDetails = () => async dispatch => {
    try {
        let response = await findThirdPartyWeeklyBillingDetails();
        if (response.data) {
            let thirdPartyBillingObj = constructThirdPartyBillingDetails(response.data);
            if (Object.keys(thirdPartyBillingObj.weeklyBillingFormattedObj).length > 0) {
                dispatch({
                    type: THIRD_PARTY_BILLING_DETAILS,
                    payload: thirdPartyBillingObj
                })
            } else {
                dispatch({
                    type: THIRD_PARTY_BILLING_DETAILS,
                    payload: null
                })
            }
        }
    } catch (e) {
        console.error(e);
        dispatch({
            type: THIRD_PARTY_BILLING_DETAILS,
            payload: null
        })
    }
}

export default getPartnerThirdPartyBillingDetails;
